import { render, staticRenderFns } from "./centerExam.vue?vue&type=template&id=3e2e58ce"
import script from "./centerExam.vue?vue&type=script&lang=js"
export * from "./centerExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports